import 'moment';

import * as React from 'react';

import moment from 'moment-timezone';
import * as PropTypes from 'prop-types';

import Alert from '../../components/Alert';
// components
import Button from '../../components/Button';
import { getTimeZone } from '../../helpers/timeUtils';
import { MessageDeliveryStatuses } from '../../types';
import Message from '../Message';
import MessagesInput from '../MessagesInput';
import { MessagesContainerProps } from './MessagesFeedTypes';

const beginningOfFeed = (messagesFeed, translate, haveMessages) => (
    <div className="messagesFeed__beginning">
        {translate('beginning_conversation')}<br/>
        {haveMessages ? moment.utc(messagesFeed.messages[0].date_added).local().tz(getTimeZone()).format('LLL') : null}
    </div>
);

const loadMoreButton = (messagesFeed, updateMessages, translate, onDesktop) => (
    <Button
        className="messagesFeed__button"
        label={onDesktop ? translate('tap_to_load_desktop') : translate('tap_to_load')}
        onClick={() => updateMessages(messagesFeed)}
    />
);

// FIXME: as long as we are filtering duplicate templates on the backend there will be no way for this to be correct
const buildButton = (messagesFeed, updateMessages, translate, onDesktop, haveMessages) => {
    // the check against 'undefined' is needed for sending message templates - currently we never reach out to commcontroller in this case
    // in the future, we could return total_count as part of the websocket response
    // FIXME: need to send total_count including error messages or else this won't work
    return (messagesFeed.messages.length === messagesFeed.total_count || messagesFeed.total_count === undefined || messagesFeed.total_count === 0) ? beginningOfFeed(messagesFeed, translate, haveMessages) : loadMoreButton(messagesFeed, updateMessages, translate, onDesktop);
};

const MessagesFeed: React.StatelessComponent<Partial<MessagesContainerProps>> = ({ contact, messagesFeed, conversationId, sendMessage, updateMessages, scrollToBottom, waitingForReplyStatus, recipient, history, twilioError, activeLanguage }, { translate, onDesktop }) => {
    const haveMessages = messagesFeed.messages && messagesFeed.messages.length;
    const lastMessageStatus = haveMessages ? messagesFeed.messages[messagesFeed.messages.length - 1].delivery_status : MessageDeliveryStatuses.NEW;
    let profanityMessage = '';
    const isProfanityMessage = lastMessageStatus === MessageDeliveryStatuses.PROFANITY ? true : false;
    if (isProfanityMessage) {
        profanityMessage = messagesFeed.messages.pop().content;
    }
    if (contact !== undefined && lastMessageStatus === MessageDeliveryStatuses.DNC) {
        contact.isDnc = true;
    }
    return (
        <div className="flexbox__column messagesFeed__column">
            <div className="messagesFeed" id="messagesFeed__scroll">
                {buildButton(messagesFeed, updateMessages, translate, onDesktop, haveMessages)}
                {haveMessages ? (messagesFeed.messages.map((message, index) => (
                    <Message
                        key={message.id}
                        sendMessage={sendMessage}
                        message={message}
                        activeLanguage={activeLanguage}
                        conversationId={conversationId}
                        scrollToBottom={scrollToBottom}
                        index={index}
                        error={twilioError}
                        isLatestMessage={messagesFeed.messages.length - 1 === index}
                    />
                ))) : null}
            </div>
            {contact && contact.isDnc &&
                <div className="messagesFeed__dnc">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM15.3333 8C15.3333 12.0501 12.0501 15.3333 8 15.3333C3.94991 15.3333 0.666667 12.0501 0.666667 8C0.666667 3.94991 3.94991 0.666667 8 0.666667C12.0501 0.666667 15.3333 3.94991 15.3333 8ZM7.47689 10.7369C7.47689 11.0636 7.73822 11.3249 8.06489 11.3249C8.39155 11.3249 8.65289 11.0636 8.65289 10.7369C8.65289 10.4103 8.39155 10.1489 8.06489 10.1489C7.73822 10.1489 7.47689 10.4103 7.47689 10.7369ZM8.32609 9.15018H7.80343L7.57943 4.46484H8.55009L8.32609 9.15018Z" fill="#D4335E"/>
                    </svg>
                    <span className="messagesFeed__dncText">This customer has requested to not be contacted.</span>
                </div>
            }
            {
                isProfanityMessage &&
                <Alert
                    message={translate('profanity_content')}
                    type={'warning'}
                    showCloseButton={true}
                />
            }
            {contact && !contact.isDnc &&
                <MessagesInput
                    conversationId={conversationId}
                    history={history}
                    sendMessage={sendMessage}
                    waitingForReplyStatus={waitingForReplyStatus}
                    loading={false} // FIXME: need loading state here
                    recipient={recipient}
                    activeLanguage={activeLanguage}
                    onDesktop={onDesktop}
                    lastMessageStatus={lastMessageStatus}
                    profanityMessage={profanityMessage}
                />
            }
        </div>
    );
};

export default MessagesFeed;

MessagesFeed.contextTypes = {
    translate: PropTypes.func.isRequired,
    onDesktop: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/sections/MessagesFeed/MessagesFeedComponent.tsx